import { ICartAttributes } from '../models/cart.models';
import { IGuestCart } from '../models/guest.models';
import { IAddress } from '../models/common.models';
import { ICustomerCheckoutData } from '../models/customer.models';

export class GuestUtils {
  //mapping function to get necessary data in needed format for harmonized delivery details page
  static createIAddressFromIGuestCart(guestCart: IGuestCart): IAddress {
    return {
      address1: guestCart.data.attributes.customerRequestData.address1,
      address2: '',
      city: guestCart.data.attributes.customerRequestData.city,
      company: guestCart.data.attributes.customerRequestData.organizationName,
      country: guestCart.data.attributes.customerRequestData.countryIso2, //create mapping for country or use iso2Code?
      email: guestCart.data.attributes.customerRequestData.emailAddress,
      firstName: guestCart.data.attributes.customerRequestData.firstName,
      isDefaultBilling: false,
      isDefaultShipping: false,
      iso2Code: guestCart.data.attributes.customerRequestData.countryIso2,
      lastName: guestCart.data.attributes.customerRequestData.lastName,
      phone: '',
      salutation: 'Mr/Mrs',
      zipCode: guestCart.data.attributes.customerRequestData.zip,
      state: guestCart.data.attributes.customerRequestData.state,
    };
  }

  //mapping function to get necessary data in needed format for harmonized delivery details page
  static createICartAttributesFromIGuestCart(guestCart: IGuestCart): ICartAttributes {
    return {
      approverDetails: {
        approverId: guestCart.data.attributes.approverDetails?.approverId ?? undefined,
        firstName: guestCart.data.attributes.approverDetails?.firstName ?? undefined,
        lastName: guestCart.data.attributes.approverDetails?.lastName ?? undefined,
        comment: guestCart.data.attributes.approverDetails?.comment ?? undefined,
        dueDate: guestCart.data.attributes.approverDetails?.dueDate ?? undefined,
        poNumber: guestCart.data.attributes.approverDetails?.poNumber ?? undefined,
        status: guestCart.data.attributes.approverDetails?.status ?? undefined,
      },
      currency: guestCart.data.attributes.currency,
      discounts: [],
      isDefault: guestCart.data.attributes.isDefault,
      name: guestCart.data.attributes.name,
      priceMode: guestCart.data.attributes.priceMode,
      store: guestCart.data.attributes.store,
      totals: guestCart.data.attributes.totals,
    };
  }

  //mapping function to get necessary data in needed format for harmonized delivery details page
  static createICustomerCheckoutDataFromIGuestCart(guestCart: IGuestCart): ICustomerCheckoutData {
    return {
      businessUnitName: '',
      businessUnitNumber: '',
      companyRoles: [],
      customerData: {
        firstName: guestCart.data.attributes.customerRequestData.firstName,
        lastName: guestCart.data.attributes.customerRequestData.lastName,
        city: guestCart.data.attributes.customerRequestData.city,
        address: guestCart.data.attributes.customerRequestData.address1,
        preferredLanguage: guestCart.data.attributes.customerRequestData.language,
        phone: '',
        zip: guestCart.data.attributes.customerRequestData.zip,
        state: guestCart.data.attributes.customerRequestData.state,
        email: guestCart.data.attributes.customerRequestData.emailAddress,
        gender: '',
        dateOfBirth: '',
        salutation: 'Mr/Mrs',
        createdAt: '',
        updatedAt: '',
        companyBusinessUnit: '',
        consentedTerms: [],
      },
      customerId: '',
      customerPreferences: {
        preferredPayment: {},
        notifications: {},
        preferredShipToId: '',
      },
    };
  }
}
